import { Injectable } from "@angular/core";
import { CanActivate, Router } from "@angular/router";
import { LocalStorageRepositoryInterface } from "../../../datastore/local/localstorage.interface";
import { UserManager } from "../../../business/managers/user.manager";
import { BACKOFFICE_LOGIN_USER_UUID } from "../../utilities/properties/base.property";

@Injectable()
export class BackofficeGuardHelper implements CanActivate {

    constructor(
        private router: Router,
        private localStorageRepository: LocalStorageRepositoryInterface,
        private userManager: UserManager) {}

    public canActivate(): boolean {
        const token = this.localStorageRepository.getToken();
        if (token !== undefined && token != null) {
            if (this.userManager.getLoggedUserId() === BACKOFFICE_LOGIN_USER_UUID) {
                return true;
            }
        }
        this.router.navigate([
            "backoffice-login"
        ]);
        return false;
    }
}
